import { render, staticRenderFns } from "./Robot_semi_detail.vue?vue&type=template&id=bdc98806&scoped=true&"
import script from "./Robot_semi_detail.vue?vue&type=script&lang=js&"
export * from "./Robot_semi_detail.vue?vue&type=script&lang=js&"
import style0 from "./Robot_semi_detail.vue?vue&type=style&index=0&id=bdc98806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc98806",
  null
  
)

export default component.exports